import { render, staticRenderFns } from "./ReserveTable.vue?vue&type=template&id=3f5fdc98&scoped=true"
import script from "./ReserveTable.vue?vue&type=script&lang=js"
export * from "./ReserveTable.vue?vue&type=script&lang=js"
import style0 from "./ReserveTable.vue?vue&type=style&index=0&id=3f5fdc98&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f5fdc98",
  null
  
)

export default component.exports